import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import type {
  IPagedFilterTownshipAreaDto,
  ITownshipAreaCreateOrUpdateDto,
  ITownshipAreaOutputDto,
} from "@models/master-data/townshipAreaModel"
import type { PagedResultDto } from "@services/dto/pagedResultDto"
import http from "../httpService"

class TownshipAreaService {
  public async getAll(
    params: IPagedFilterTownshipAreaDto
  ): Promise<PagedResultDto<ITownshipAreaOutputDto>> {
    const res = await http.get("api/services/app/TownshipArea/GetAll", { params })
    return res.data.result
  }

  public async get(id: number): Promise<ITownshipAreaOutputDto> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/TownshipArea/Get", {
      params: { id },
    })
    return res.data.result
  }

  public async createOrUpdate(
    body: ITownshipAreaCreateOrUpdateDto
  ): Promise<ITownshipAreaOutputDto> {
    const res = await http.post("api/services/app/TownshipArea/CreateOrUpdate", body)
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }

  public async activate(id: number, isActive: boolean) {
    const res = await http.post(
      "api/services/app/TownshipArea/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }

  public async getList(): Promise<ITownshipAreaOutputDto[]> {
    const res = await http.get("api/services/app/TownshipArea/GetList")
    return res.data.result
  }
}

export default new TownshipAreaService()
